import { FC } from "react"

import { Button, Stack } from "@mui/material"
import { useTranslation } from "react-i18next"

interface IProps {
  onClick: (anchor: HTMLElement) => void
}

const AddSchoolGroupCard: FC<IProps> = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100%"
      minHeight="160px"
      px="16px"
      py="24px"
      border={(theme) => `1px dashed ${theme.palette.mockup.primary95}`}
      borderRadius="16px"
      bgcolor={(theme) => theme.palette.common.white}
    >
      <Button
        variant="outlined"
        onClick={(e) => onClick(e.currentTarget)}
        sx={{ whiteSpace: "nowrap" }}
      >
        + {t("group.addGroup")}
      </Button>
    </Stack>
  )
}

export default AddSchoolGroupCard
